<mat-card class="frequency-table-card">
  <mat-card-header class="frequency-table-card__header">
    <mat-card-title>{{ i18n.title }}</mat-card-title>
    <mat-card-subtitle>{{ totalMeasurementCount() | number }}件</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="table-toolbar frequency-table-toolbar" aria-hidden="true"></div>
    <div class="user-list-container frequency-table-wrapper">
      <table mat-table [dataSource]="dataSource()" matSort class="user_record_table frequency-table">
        <ng-container matColumnDef="dateLabel">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ i18n.date }}</th>
          <td mat-cell *matCellDef="let row">{{ row.dateLabel }}</td>
          <td mat-footer-cell *matFooterCellDef class="frequency-table__footer-label">
            {{ i18n.total }}
          </td>
        </ng-container>

        <ng-container matColumnDef="measurementCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ i18n.measurementCount }}</th>
          <td mat-cell *matCellDef="let row">{{ row.measurementCount | number }}</td>
          <td mat-footer-cell *matFooterCellDef class="frequency-table__footer-value">
            {{ totalMeasurementCount() | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountList">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ i18n.accountList }}</th>
          <td mat-cell *matCellDef="let row" class="frequency-table__account-list-cell">
            <span class="frequency-table__account-list">{{ formatAccountList(row) }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="frequency-table__footer-value">
            -
          </td>
        </ng-container>

        <ng-container matColumnDef="estimatedRegion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ i18n.estimatedRegion }}</th>
          <td mat-cell *matCellDef="let row" class="frequency-table__estimated-region-cell">
            <span class="frequency-table__estimated-region">{{ formatEstimatedRegion(row) }}</span>
          </td>
          <td mat-footer-cell *matFooterCellDef class="frequency-table__footer-value">
            -
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="frequency-table__data-row"
          [class.is-selected]="isRowSelected(row)"
          (click)="onRowClick(row)"
        ></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns" class="frequency-table__footer-row"></tr>
      </table>
    </div>
    <mat-paginator
      class="user-list-paginator"
      [pageSize]="10"
      [pageSizeOptions]="pageSizeOptions"
    ></mat-paginator>
  </mat-card-content>
</mat-card>
